import React from 'react';
import QuizApp from './components/quiz/QuizApp';

function App() {
  return <QuizApp />;
}

export default App;